"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAIVisualizationBlockSchema = exports.AnyBreakdownSchema = exports.SegmentBreakdownSchema = exports.DimensionBreakdownSchema = exports.SegmentBucketSchema = exports.AnySegmentReducerSchema = exports.SegmentReducerPercentileSchema = exports.SegmentReducerAggregationSchema = exports.ConditionGroupSchema = exports.ConditionSchema = exports.AggregateTypeSchema = exports.AnyPeriodSchema = exports.AbsolutePeriodSchema = exports.RelativePeriodSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const visualization_schema_1 = require("@varos/visualization-schema");
const visualization_1 = require("../../visualization");
// Metric
const AggregationSchema = zod_1.default.object({
    kind: zod_1.default.literal('aggregation'),
    key: zod_1.default.string().nullable(),
    display_name: zod_1.default.string().nullable(),
    namespace: zod_1.default.string(),
    table: zod_1.default.string().nullable(),
    column: zod_1.default.string().nullable(),
    type: visualization_schema_1.ColumnAggregationTypeSchema,
    visible: zod_1.default.boolean().nullable(),
}, { description: 'aggregations allow you to rollup scalar values' });
const FormulaSchema = zod_1.default.object({
    kind: zod_1.default.literal('formula'),
    key: zod_1.default.string().nullable(),
    display_name: zod_1.default.string().nullable(),
    formula: zod_1.default.string(),
    format: visualization_1.ValueFormatSchema.nullable(),
    visible: zod_1.default.boolean().nullable(),
}, { description: 'formulas apply computations on aggregated metrics' });
const AnyMetricSchema = zod_1.default.discriminatedUnion('kind', [AggregationSchema, FormulaSchema]);
// Period
exports.RelativePeriodSchema = zod_1.default.object({
    kind: zod_1.default.literal('relative'),
    interval: zod_1.default.enum(['day', 'week', 'month', 'quarter', 'year', 'period']),
    amount: zod_1.default.number(),
});
exports.AbsolutePeriodSchema = zod_1.default.object({
    kind: zod_1.default.literal('absolute'),
    start: zod_1.default.string(),
    end: zod_1.default.string(),
});
exports.AnyPeriodSchema = zod_1.default.discriminatedUnion('kind', [
    exports.RelativePeriodSchema,
    exports.AbsolutePeriodSchema,
]);
// Condition
exports.AggregateTypeSchema = zod_1.default.enum(['sum', 'average', 'count', 'distribution', 'percentile'], { description: 'aggregate the metric of this condition' });
exports.ConditionSchema = zod_1.default
    .object({
    key: zod_1.default.string({ description: 'Name of column to filter on' }),
    operator: visualization_schema_1.OperatorSchema,
    value: zod_1.default.union([zod_1.default.number(), zod_1.default.string()]),
    aggregate: exports.AggregateTypeSchema.nullable(),
})
    .openapi('ConditionObject');
exports.ConditionGroupSchema = zod_1.default
    .object({
    mode: zod_1.default.enum(['and', 'or']),
    conditions: zod_1.default.array(exports.ConditionSchema),
})
    .openapi('ConditionGroupObject');
// Breakdown
exports.SegmentReducerAggregationSchema = zod_1.default.object({
    type: zod_1.default.literal('average'),
});
exports.SegmentReducerPercentileSchema = zod_1.default.object({
    type: zod_1.default.literal('percentile'),
    value: zod_1.default.number(),
});
exports.AnySegmentReducerSchema = zod_1.default.union([
    exports.SegmentReducerAggregationSchema,
    exports.SegmentReducerPercentileSchema,
]);
exports.SegmentBucketSchema = zod_1.default.object({
    key: zod_1.default.string(),
    reducer: exports.AnySegmentReducerSchema,
    // filter: ConditionGroupSchema.nullable(),
});
exports.DimensionBreakdownSchema = zod_1.default.object({
    kind: zod_1.default.literal('dimension'),
    key: zod_1.default.string(),
});
exports.SegmentBreakdownSchema = zod_1.default.object({
    kind: zod_1.default.literal('segment'),
    buckets: zod_1.default.array(exports.SegmentBucketSchema),
});
exports.AnyBreakdownSchema = zod_1.default.discriminatedUnion('kind', [
    exports.DimensionBreakdownSchema,
    // SegmentBreakdownSchema,
]);
// Visualization
exports.OpenAIVisualizationBlockSchema = zod_1.default.object({
    kind: zod_1.default.literal('visualization'),
    type: zod_1.default.enum(['trend', 'category']),
    metrics: zod_1.default.array(AnyMetricSchema),
    granularity: visualization_schema_1.TimeGranularitySchema.nullable(),
    // breakdown: z.array(AnyBreakdownSchema).nullable(),
    period: exports.AnyPeriodSchema.nullable(),
    // filter: ConditionGroupSchema.nullable(),
});
//# sourceMappingURL=openAIVisualizationSchema.js.map